module.exports = __webpack_public_path__ + "img/video_shrink.d4001699.png";